import React, { useState, useEffect } from "react";
import globals from '../../../Globals';
import { Calendar, MapPin, Plus, Trash2, Copy , Edit , Eye, Users} from 'lucide-react';

const API = globals.API;

const formatDateForInput = (date) => {
  if (!date) return '';
  if (typeof date === 'string' && date.length === 10) return date;
  return new Date(date).toISOString().split('T')[0];
};

const uploadSingleImage = async (file, apiBase) => {
  const fd = new FormData();
  fd.append('image', file);
  const res = await fetch(`${apiBase}/events/upload-image`, { method: 'POST', body: fd });
  const data = await res.json();
  if (!data.success) throw new Error(data.message || 'Upload failed');
  return data.url;
};

const uploadPdfFile = async (file, apiBase) => {
  const fd = new FormData();
  fd.append('pdf', file);
  const res = await fetch(`${apiBase}/events/upload-pdf`, { method: 'POST', body: fd });
  const data = await res.json();
  if (!data.success) throw new Error(data.message || 'PDF upload failed');
  return { url: data.url, publicId: data.publicId };
};

const DashboardEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentEvent, setCurrentEvent] = useState(null);
  const [categoryFilter, setCategoryFilter] = useState('all');
  const [pdfFile, setPdfFile] = useState(null);
  const [pdfUploading, setPdfUploading] = useState(false);


 const [formData, setFormData] = useState({
    title: '',
    destination: '',
    description: '',
    program: '', programDetails: [], gallery: [],
    includedServices: '',
    excludedServices: '',
    voldetails: '',
    otherRecommendations: '',
    category: 'voyage',
    isActive: true,
    image: null,
    pdfUrl: '',
    pdfPublicId: '',
    departureDates: [{
      departureDate: '',
      returnDate: '',
      availableSeats: 20,
      isAvailable: true,
      pricing: {
        b2c: { price: '', tarifdemidouble: '', spplementsingle: '', tarif3eme: '', enf2_6: '', enf6_12: '' ,bebe: ''},
        b2b: { enabled: false, price: '', tarifdemidouble: '', spplementsingle: '', tarif3eme: '', enf2_6: '', enf6_12: '' ,bebe: ''}
      }
    }]
  });


  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const response = await fetch(`${API}/events`);
      const result = await response.json();

      setEvents(result.data.map(evt => ({
        id: evt._id,
        title: evt.title,
        destination: evt.destination,
        description: evt.description,
        program: evt.program,
        programDetails: evt.programDetails || [],
        gallery: evt.gallery || [],
        includedServices: evt.includedServices,
        excludedServices: evt.excludedServices,
        voldetails: evt.voldetails,
        otherRecommendations: evt.otherRecommendations,
        category: evt.category,
        image: evt.image,
        pdfUrl: evt.pdfUrl || '',
        pdfPublicId: evt.pdfPublicId || '',
        isActive: evt.isActive,
        departureDates: evt.departureDates || []
      })));
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

const handleCreate = () => {
  setIsEditing(false);
  setCurrentEvent(null);
  setFormData({
    title: '', destination: '', description: '', program: '', programDetails: [], gallery: [], includedServices: '', excludedServices: '', voldetails: '', otherRecommendations: '',
    category: 'voyage', isActive: true, image: null, pdfUrl: '', pdfPublicId: '',
    departureDates: [{
      departureDate: '', returnDate: '', availableSeats: 20, isAvailable: true,
      pricing: {
        b2c: { 
          price: '', 
          tarifdemidouble: '', 
          spplementsingle: '', 
          tarif3eme: '', 
          enf2_6: '', 
          enf6_12: '',
          bebe: '' // 🆕 ADD THIS
        },
        b2b: { 
          enabled: false, 
          price: '', 
          tarifdemidouble: '', 
          spplementsingle: '', 
          tarif3eme: '', 
          enf2_6: '', 
          enf6_12: '',
          bebe: '' // 🆕 ADD THIS
        }
      }
    }]
  });
  setShowModal(true);
};

const handleEdit = (event) => {
  setIsEditing(true);
  setCurrentEvent(event);

  setPdfFile(null);
  setFormData({
    ...event,
    includedServices: Array.isArray(event.includedServices) ? event.includedServices.join(', ') : '',
    excludedServices: Array.isArray(event.excludedServices) ? event.excludedServices.join(', ') : '',
    image: null,
    pdfUrl: event.pdfUrl || '',
    pdfPublicId: event.pdfPublicId || '',
    departureDates: event.departureDates.length
      ? event.departureDates.map(dep => ({
          ...dep,
          departureDate: formatDateForInput(dep.departureDate),
          returnDate: formatDateForInput(dep.returnDate)
        }))
      : [{
          departureDate: '',
          returnDate: '',
          availableSeats: 20,
          isAvailable: true,
          pricing: {
            b2c: { 
              price: '', 
              tarifdemidouble: '', 
              spplementsingle: '', 
              tarif3eme: '', 
              enf2_6: '', 
              enf6_12: '',
              bebe: '' // 🆕 ADD THIS
            },
            b2b: { 
              enabled: false, 
              price: '', 
              tarifdemidouble: '', 
              spplementsingle: '', 
              tarif3eme: '', 
              enf2_6: '', 
              enf6_12: '',
              bebe: '' // 🆕 ADD THIS
            }
          }
        }]
  });

  setShowModal(true);
};
  const handleViewDetails = (event) => {
    setCurrentEvent(event);
    setShowDetailsModal(true);
  };

  const addDepartureDate = () => {
    setFormData(prev => ({
      ...prev,
      departureDates: [...prev.departureDates, {
        departureDate: '', returnDate: '', availableSeats: 20, isAvailable: true,
        pricing: {
          b2c: { price: '', tarifdemidouble: '', spplementsingle: '', tarif3eme: '', enf2_6: '', enf6_12: '',bebe: '' },
          b2b: { enabled: false, price: '', tarifdemidouble: '', spplementsingle: '', tarif3eme: '', enf2_6: '', enf6_12: '',bebe: '' }
        }
      }]
    }));
  };

  const removeDepartureDate = (index) => {
    if (formData.departureDates.length <= 1) {
      alert('Au moins une date de départ est requise');
      return;
    }
    setFormData(prev => ({
      ...prev,
      departureDates: prev.departureDates.filter((_, i) => i !== index)
    }));
  };

  const updateDepartureField = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      departureDates: prev.departureDates.map((dep, i) => 
        i === index ? { ...dep, [field]: value } : dep
      )
    }));
  };

  const updatePricing = (index, type, field, value) => {
    setFormData(prev => ({
      ...prev,
      departureDates: prev.departureDates.map((dep, i) => 
        i === index ? {
          ...dep,
          pricing: {
            ...dep.pricing,
            [type]: { ...dep.pricing[type], [field]: value }
          }
        } : dep
      )
    }));
  };

  const copyB2CtoB2B = (index) => {
    const b2c = formData.departureDates[index].pricing.b2c;
    setFormData(prev => ({
      ...prev,
      departureDates: prev.departureDates.map((dep, i) => 
        i === index ? {
          ...dep,
          pricing: {
            ...dep.pricing,
            b2b: { ...dep.pricing.b2b, ...b2c, enabled: dep.pricing.b2b.enabled }
          }
        } : dep
      )
    }));
  };

const applyDiscount = (index, percent) => {
  const b2c = formData.departureDates[index].pricing.b2c;
  const multiplier = (100 - percent) / 100;
  setFormData(prev => ({
    ...prev,
    departureDates: prev.departureDates.map((dep, i) => 
      i === index ? {
        ...dep,
        pricing: {
          ...dep.pricing,
          b2b: {
            ...dep.pricing.b2b,
            price: b2c.price ? Math.round(b2c.price * multiplier) : '',
            tarifdemidouble: b2c.tarifdemidouble ? Math.round(b2c.tarifdemidouble * multiplier) : '',
            spplementsingle: b2c.spplementsingle ? Math.round(b2c.spplementsingle * multiplier) : '',
            tarif3eme: b2c.tarif3eme ? Math.round(b2c.tarif3eme * multiplier) : '',
            enf2_6: b2c.enf2_6 ? Math.round(b2c.enf2_6 * multiplier) : '',
            enf6_12: b2c.enf6_12 ? Math.round(b2c.enf6_12 * multiplier) : '',
            bebe: b2c.bebe ? Math.round(b2c.bebe * multiplier) : '' // 🆕 ADD THIS
          }
        }
      } : dep
    )
  }));
}; 
  const handleDelete = async (eventId) => {
  if (!window.confirm("Voulez-vous vraiment supprimer cet événement ?")) return;

  try {
    await fetch(`${API}/events/${eventId}`, {
      method: 'DELETE',
    });

    // Remove the deleted event from the state
    setEvents(prev => prev.filter(evt => evt.id !== eventId));
  } catch (err) {
    alert(`Erreur lors de la suppression: ${err.message}`);
  }
};


 const handleSubmit = async (e) => {
  e.preventDefault();

  // ✅ Validate departure dates BEFORE sending
  if (!formData.departureDates.length) {
    alert('Au moins une date de départ est requise');
    return;
  }

  const submitData = new FormData();

  submitData.append('title', formData.title);
  submitData.append('destination', formData.destination);
  submitData.append('description', formData.description);
  submitData.append('program', formData.program);
  submitData.append('programDetails', JSON.stringify(formData.programDetails));
  submitData.append('gallery', JSON.stringify(formData.gallery));
  submitData.append('category', formData.category);
  submitData.append('isActive', String(formData.isActive));
  submitData.append('voldetails', formData.voldetails || '');
  submitData.append('otherRecommendations', formData.otherRecommendations || '');

  if (formData.includedServices) {
    submitData.append(
      'includedServices',
      JSON.stringify(
        formData.includedServices
          .split(',')
          .map(s => s.trim())
          .filter(Boolean)
      )
    );
  }

  if (formData.excludedServices) {
    submitData.append(
      'excludedServices',
      JSON.stringify(
        formData.excludedServices
          .split(',')
          .map(s => s.trim())
          .filter(Boolean)
      )
    );
  }

  // ✅ CORRECT departure dates handling
  formData.departureDates.forEach((dep, i) => {
    if (!dep.departureDate) {
      alert(`Date de départ manquante (ligne ${i + 1})`);
      return;
    }

    // 🚀 IMPORTANT: send raw date string
    submitData.append(`departures[${i}][departureDate]`, dep.departureDate);

    if (dep.returnDate) {
      submitData.append(`departures[${i}][returnDate]`, dep.returnDate);
    }

    submitData.append(`departures[${i}][availableSeats]`, dep.availableSeats ?? '');
    submitData.append(`departures[${i}][isAvailable]`, String(dep.isAvailable));

    // ---- B2C Pricing ----
    submitData.append(`departures[${i}][pricing][b2c][price]`, dep.pricing.b2c.price || 0);
    submitData.append(`departures[${i}][pricing][b2c][tarifdemidouble]`, dep.pricing.b2c.tarifdemidouble || '');
    submitData.append(`departures[${i}][pricing][b2c][spplementsingle]`, dep.pricing.b2c.spplementsingle || '');
    submitData.append(`departures[${i}][pricing][b2c][tarif3eme]`, dep.pricing.b2c.tarif3eme || '');
    submitData.append(`departures[${i}][pricing][b2c][enf2_6]`, dep.pricing.b2c.enf2_6 || '');
    submitData.append(`departures[${i}][pricing][b2c][enf6_12]`, dep.pricing.b2c.enf6_12 || '');
    submitData.append(`departures[${i}][pricing][b2c][bebe]`, dep.pricing.b2c.bebe || '');
// ... and in B2B section:

    // ---- B2B Pricing ----
    submitData.append(
      `departures[${i}][pricing][b2b][enabled]`,
      String(dep.pricing.b2b.enabled)
    );

    if (dep.pricing.b2b.enabled) {
      submitData.append(`departures[${i}][pricing][b2b][price]`, dep.pricing.b2b.price || '');
      submitData.append(`departures[${i}][pricing][b2b][tarifdemidouble]`, dep.pricing.b2b.tarifdemidouble || '');
      submitData.append(`departures[${i}][pricing][b2b][spplementsingle]`, dep.pricing.b2b.spplementsingle || '');
      submitData.append(`departures[${i}][pricing][b2b][tarif3eme]`, dep.pricing.b2b.tarif3eme || '');
      submitData.append(`departures[${i}][pricing][b2b][enf2_6]`, dep.pricing.b2b.enf2_6 || '');
      submitData.append(`departures[${i}][pricing][b2b][enf6_12]`, dep.pricing.b2b.enf6_12 || '');
    submitData.append(`departures[${i}][pricing][b2b][bebe]`, dep.pricing.b2b.bebe || '');
    }
  });

  if (formData.image) {
    submitData.append('image', formData.image);
  }

  // Upload PDF if a new file was selected
  let pdfUrl = formData.pdfUrl || '';
  let pdfPublicId = formData.pdfPublicId || '';
  if (pdfFile) {
    setPdfUploading(true);
    try {
      const result = await uploadPdfFile(pdfFile, API);
      pdfUrl = result.url;
      pdfPublicId = result.publicId || '';
    } catch (err) {
      alert(`Erreur upload PDF: ${err.message}`);
      setPdfUploading(false);
      return;
    }
    setPdfUploading(false);
  }
  if (pdfUrl) {
    submitData.append('pdfUrl', pdfUrl);
    submitData.append('pdfPublicId', pdfPublicId);
  }

  try {
    const url = isEditing
      ? `${API}/events/${currentEvent.id}`
      : `${API}/events/add`;

    await fetch(url, {
      method: isEditing ? 'PUT' : 'POST',
      body: submitData,
    });

    setPdfFile(null);
    setShowModal(false);
    fetchEvents();
  } catch (err) {
    alert(`Erreur: ${err.message}`);
  }
};

  if (loading) return <div style={{padding: '40px', textAlign: 'center'}}>Chargement...</div>;

  return (
    <div style={{background: '#f5f7fa', minHeight: '100vh', padding: '30px', fontFamily: 'system-ui'}}>
      <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '30px'}}>
        <h1 style={{fontSize: '32px', fontWeight: '700'}}>Événements</h1>
        <button onClick={handleCreate} style={{background: '#4F46E5', color: 'white', border: 'none', padding: '12px 24px', borderRadius: '8px', cursor: 'pointer', fontWeight: '600'}}>
          + Créer
        </button>
      </div>

      <div style={{marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '12px'}}>
  <label style={{fontWeight: '600'}}>Filtrer par catégorie :</label>
  <select
    value={categoryFilter}
    onChange={(e) => setCategoryFilter(e.target.value)}
    style={{padding: '8px', borderRadius: '6px', border: '1px solid #e2e8f0'}}
  >
    <option value="all">Toutes</option>
    <option value="voyage">Voyage</option>
    <option value="sport">Sport</option>
    <option value="omra">Omra</option>
  </select>
</div>


      <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', gap: '24px'}}>
        {events
         .filter(evt => categoryFilter === 'all' || evt.category === categoryFilter)
        .map(event => (
          <div key={event.id} style={{background: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.1)'}}>
            <img src={event.image} alt={event.title} style={{width: '100%', height: '180px', objectFit: 'cover'}} />
            <div style={{padding: '20px'}}>
              <h3 style={{fontSize: '18px', fontWeight: '700', marginBottom: '8px'}}>{event.title}</h3>
              <div style={{display: 'flex', alignItems: 'center', gap: '6px', color: '#4F46E5', fontSize: '14px', marginBottom: '12px'}}>
                <MapPin size={14} />
                {event.location}
              </div>
              <div style={{display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap'}}>
                <span style={{padding: '4px 10px', borderRadius: '6px', fontSize: '12px', background: '#f0fdf4', color: '#065f46'}}>
                  <Calendar size={12} style={{display: 'inline', marginRight: '4px'}} />
                  {event.departureDates.length} départ{event.departureDates.length > 1 ? 's' : ''}
                </span>
                <span style={{padding: '4px 10px', borderRadius: '6px', fontSize: '12px', background: '#eff6ff', color: '#1e40af'}}>
                  {event.category}
                </span>
              </div>
             <div style={{display: 'flex', gap: '8px'}}>
  <button
    onClick={() => handleViewDetails(event)}
    style={{flex: 1, padding: '10px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px'}}
  >
    <Eye size={16} /> Détails
  </button>

  <button
    onClick={() => handleEdit(event)}
    style={{flex: 1, padding: '10px', background: '#4F46E5', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px'}}
  >
    <Edit size={16} /> Modifier
  </button>

  <button
    onClick={() => handleDelete(event.id)}
    style={{flex: 1, padding: '10px', background: '#dc2626', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px'}}
  >
    <Trash2 size={16} /> Supprimer
  </button>
</div>

            </div>
          </div>
        ))}
      </div>

      {/* Details Modal */}
      {showDetailsModal && currentEvent && (
        <div onClick={() => setShowDetailsModal(false)} style={{position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px'}}>
          <div onClick={(e) => e.stopPropagation()} style={{background: 'white', borderRadius: '12px', maxWidth: '1000px', width: '100%', maxHeight: '90vh', overflowY: 'auto'}}>
            <div style={{padding: '24px', borderBottom: '1px solid #e2e8f0', position: 'sticky', top: 0, background: 'white', zIndex: 10}}>
              <h2 style={{fontSize: '24px', fontWeight: '700'}}>{currentEvent.title}</h2>
              <div style={{display: 'flex', alignItems: 'center', gap: '8px', color: '#64748b', fontSize: '14px', marginTop: '8px'}}>
                <MapPin size={16} />
                {currentEvent.location}
              </div>
            </div>

            <div style={{padding: '24px'}}>
              <img src={currentEvent.image} alt={currentEvent.title} style={{width: '100%', height: '300px', objectFit: 'cover', borderRadius: '8px', marginBottom: '24px'}} />

              <div style={{marginBottom: '24px'}}>
                <h3 style={{fontSize: '18px', fontWeight: '600', marginBottom: '12px'}}>Description</h3>
                <p style={{color: '#475569', lineHeight: '1.6'}}>{currentEvent.description}</p>
              </div>

              <div style={{marginBottom: '24px'}}>
                <h3 style={{fontSize: '18px', fontWeight: '600', marginBottom: '12px'}}>Programme</h3>
                <p style={{color: '#475569', lineHeight: '1.6', whiteSpace: 'pre-wrap'}}>{currentEvent.program}</p>
              </div>

              {currentEvent.includedServices && currentEvent.includedServices.length > 0 && (
                <div style={{marginBottom: '24px'}}>
                  <h3 style={{fontSize: '18px', fontWeight: '600', marginBottom: '12px'}}>Services inclus</h3>
                  <ul style={{color: '#475569', lineHeight: '1.8', paddingLeft: '20px'}}>
                    {currentEvent.includedServices.map((service, idx) => (
                      <li key={idx}>{service}</li>
                    ))}
                  </ul>
                </div>
              )}
              {currentEvent.voldetails && (
  <div style={{marginBottom: '24px'}}>
    <h3 style={{fontSize: '18px', fontWeight: '600', marginBottom: '12px'}}>Détails vol</h3>
    <p style={{color: '#475569', lineHeight: '1.6'}}>{currentEvent.voldetails}</p>
  </div>
)}

{currentEvent.otherRecommendations && (
  <div style={{marginBottom: '24px'}}>
    <h3 style={{fontSize: '18px', fontWeight: '600', marginBottom: '12px'}}>Autres recommandations</h3>
    <p style={{color: '#475569', lineHeight: '1.6'}}>{currentEvent.otherRecommendations}</p>
  </div>
)}

              {currentEvent.excludedServices && currentEvent.excludedServices.length > 0 && (
                <div style={{marginBottom: '24px'}}>
                  <h3 style={{fontSize: '18px', fontWeight: '600', marginBottom: '12px'}}>Services non inclus</h3>
                  <ul style={{color: '#475569', lineHeight: '1.8', paddingLeft: '20px'}}>
                    {currentEvent.excludedServices.map((service, idx) => (
                      <li key={idx}>{service}</li>
                    ))}
                  </ul>
                </div>
              )}

              <div style={{marginBottom: '24px'}}>
                <h3 style={{fontSize: '18px', fontWeight: '600', marginBottom: '16px'}}>Dates de départ et tarifs</h3>
                {currentEvent.departureDates.map((dep, idx) => (
                  <div key={idx} style={{padding: '20px', background: '#f8fafc', borderRadius: '8px', marginBottom: '16px', border: '1px solid #e2e8f0'}}>
                    <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '16px', flexWrap: 'wrap', gap: '12px'}}>
                      <div>
                        <div style={{fontSize: '14px', fontWeight: '600', color: '#0f172a', marginBottom: '4px'}}>
                          <Calendar size={16} style={{display: 'inline', marginRight: '6px'}} />
                          Départ: {new Date(dep.departureDate).toLocaleDateString('fr-FR')}
                        </div>
                        {dep.returnDate && (
                          <div style={{fontSize: '13px', color: '#64748b'}}>
                            Retour: {new Date(dep.returnDate).toLocaleDateString('fr-FR')}
                          </div>
                        )}
                      </div>
                      <div style={{display: 'flex', gap: '12px', alignItems: 'center'}}>
                        {dep.availableSeats && (
                          <span style={{padding: '4px 12px', background: '#dbeafe', color: '#1e40af', borderRadius: '6px', fontSize: '13px', fontWeight: '600'}}>
                            <Users size={14} style={{display: 'inline', marginRight: '4px'}} />
                            {dep.availableSeats} places
                          </span>
                        )}
                        <span style={{padding: '4px 12px', background: dep.isAvailable ? '#dcfce7' : '#fee2e2', color: dep.isAvailable ? '#166534' : '#991b1b', borderRadius: '6px', fontSize: '13px', fontWeight: '600'}}>
                          {dep.isAvailable ? 'Disponible' : 'Complet'}
                        </span>
                      </div>
                    </div>

                    <div style={{display: 'grid', gridTemplateColumns: dep.pricing?.b2b?.enabled ? '1fr 1fr' : '1fr', gap: '16px'}}>
                      {/* B2C Pricing */}
                      <div style={{padding: '16px', background: 'white', borderRadius: '8px', border: '2px solid #10b981'}}>
                        <div style={{fontSize: '15px', fontWeight: '700', color: '#065f46', marginBottom: '12px'}}>💰 Tarifs B2C</div>
                        <div style={{display: 'grid', gap: '8px'}}>
                          {dep.pricing?.b2c?.price && (
                            <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '13px'}}>
                              <span style={{color: '#64748b'}}>Prix base:</span>
                              <span style={{fontWeight: '600', color: '#0f172a'}}>{dep.pricing.b2c.price} DT</span>
                            </div>
                          )}
                          {dep.pricing?.b2c?.tarifdemidouble && (
                            <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '13px'}}>
                              <span style={{color: '#64748b'}}>Demi-double:</span>
                              <span style={{fontWeight: '600', color: '#0f172a'}}>{dep.pricing.b2c.tarifdemidouble} DT</span>
                            </div>
                          )}
                          {dep.pricing?.b2c?.spplementsingle && (
                            <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '13px'}}>
                              <span style={{color: '#64748b'}}>Supplément single:</span>
                              <span style={{fontWeight: '600', color: '#0f172a'}}>{dep.pricing.b2c.spplementsingle} DT</span>
                            </div>
                          )}
                          {dep.pricing?.b2c?.tarif3eme && (
                            <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '13px'}}>
                              <span style={{color: '#64748b'}}>Tarif 3ème:</span>
                              <span style={{fontWeight: '600', color: '#0f172a'}}>{dep.pricing.b2c.tarif3eme} DT</span>
                            </div>
                          )}
                          {dep.pricing?.b2c?.enf2_6 && (
                            <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '13px'}}>
                              <span style={{color: '#64748b'}}>Enfant 2-6 ans:</span>
                              <span style={{fontWeight: '600', color: '#0f172a'}}>{dep.pricing.b2c.enf2_6} DT</span>
                            </div>
                          )}
                          {dep.pricing?.b2c?.enf6_12 && (
                            <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '13px'}}>
                              <span style={{color: '#64748b'}}>Enfant 6-12 ans:</span>
                              <span style={{fontWeight: '600', color: '#0f172a'}}>{dep.pricing.b2c.enf6_12} DT</span>
                            </div>
                          )}
{dep.pricing?.b2c?.bebe && (
  <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '13px'}}>
    <span style={{color: '#64748b'}}>Bébé 0-2 ans:</span>
    <span style={{fontWeight: '600', color: '#0f172a'}}>{dep.pricing.b2c.bebe} DT</span>
  </div>
)}
                        </div>
                      </div>

                      {/* B2B Pricing */}
                      {dep.pricing?.b2b?.enabled && (
                        <div style={{padding: '16px', background: 'white', borderRadius: '8px', border: '2px solid #3b82f6'}}>
                          <div style={{fontSize: '15px', fontWeight: '700', color: '#1e40af', marginBottom: '12px'}}>🤝 Tarifs B2B</div>
                          <div style={{display: 'grid', gap: '8px'}}>
                            {dep.pricing.b2b.price && (
                              <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '13px'}}>
                                <span style={{color: '#64748b'}}>Prix base:</span>
                                <span style={{fontWeight: '600', color: '#0f172a'}}>{dep.pricing.b2b.price} DT</span>
                              </div>
                            )}
                            {dep.pricing.b2b.tarifdemidouble && (
                              <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '13px'}}>
                                <span style={{color: '#64748b'}}>Demi-double:</span>
                                <span style={{fontWeight: '600', color: '#0f172a'}}>{dep.pricing.b2b.tarifdemidouble} DT</span>
                              </div>
                            )}
                            {dep.pricing.b2b.spplementsingle && (
                              <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '13px'}}>
                                <span style={{color: '#64748b'}}>Supplément single:</span>
                                <span style={{fontWeight: '600', color: '#0f172a'}}>{dep.pricing.b2b.spplementsingle} DT</span>
                              </div>
                            )}
                            {dep.pricing.b2b.tarif3eme && (
                              <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '13px'}}>
                                <span style={{color: '#64748b'}}>Tarif 3ème:</span>
                                <span style={{fontWeight: '600', color: '#0f172a'}}>{dep.pricing.b2b.tarif3eme} DT</span>
                              </div>
                            )}
                            {dep.pricing.b2b.enf2_6 && (
                              <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '13px'}}>
                                <span style={{color: '#64748b'}}>Enfant 2-6 ans:</span>
                                <span style={{fontWeight: '600', color: '#0f172a'}}>{dep.pricing.b2b.enf2_6} DT</span>
                              </div>
                            )}
                            {dep.pricing.b2b.enf6_12 && (
                              <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '13px'}}>
                                <span style={{color: '#64748b'}}>Enfant 6-12 ans:</span>
                                <span style={{fontWeight: '600', color: '#0f172a'}}>{dep.pricing.b2b.enf6_12} DT</span>
                              </div>
                            )}
                            {dep.pricing.b2b.bebe && (
  <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '13px'}}>
    <span style={{color: '#64748b'}}>Bébé 0-2 ans:</span>
    <span style={{fontWeight: '600', color: '#0f172a'}}>{dep.pricing.b2b.bebe} DT</span>
  </div>
)}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit/Create Modal */}
      {showModal && (
        <div onClick={() => setShowModal(false)} style={{position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px'}}>
          <div onClick={(e) => e.stopPropagation()} style={{background: 'white', borderRadius: '12px', maxWidth: '1100px', width: '100%', maxHeight: '90vh', overflowY: 'auto'}}>
            <div style={{padding: '24px', borderBottom: '1px solid #e2e8f0', position: 'sticky', top: 0, background: 'white', zIndex: 10}}>
              <h2 style={{fontSize: '24px', fontWeight: '700'}}>{isEditing ? 'Modifier' : 'Créer'} un événement</h2>
            </div>

            <form onSubmit={handleSubmit} style={{padding: '24px'}}>
              <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px'}}>
                <input type="text" placeholder="Titre" value={formData.title} onChange={(e) => setFormData({...formData, title: e.target.value})} required style={{padding: '10px', border: '1px solid #e2e8f0', borderRadius: '6px'}} />
                <input type="text" placeholder="Destination" value={formData.destination} onChange={(e) => setFormData({...formData, destination: e.target.value})} required style={{padding: '10px', border: '1px solid #e2e8f0', borderRadius: '6px'}} />
                <select value={formData.category} onChange={(e) => setFormData({...formData, category: e.target.value})} style={{padding: '10px', border: '1px solid #e2e8f0', borderRadius: '6px'}}>
                  <option value="voyage">Voyage</option>
                  <option value="sport">Sport</option>
                  <option value="omra">Omra</option>
                  <option value="other">Autre</option>
                </select>
                <input type="file" accept="image/*" onChange={(e) => setFormData({...formData, image: e.target.files[0]})} style={{padding: '10px', border: '1px solid #e2e8f0', borderRadius: '6px'}} />
                {/* PDF Programme */}
                <div style={{marginTop: '12px'}}>
                  <label style={{display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '14px'}}>
                    Programme PDF
                  </label>
                  <input
                    type="file"
                    accept="application/pdf"
                    onChange={(e) => setPdfFile(e.target.files[0] || null)}
                    style={{padding: '10px', border: '1px solid #e2e8f0', borderRadius: '6px', width: '100%'}}
                  />
                  {formData.pdfUrl && !pdfFile && (
                    <div style={{marginTop: '6px', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: '#4F46E5'}}>
                      <span>📄 PDF existant :</span>
                      <a href={formData.pdfUrl} target="_blank" rel="noreferrer" style={{color: '#4F46E5', textDecoration: 'underline'}}>
                        Voir le PDF actuel
                      </a>
                      <button
                        type="button"
                        onClick={() => setFormData({...formData, pdfUrl: '', pdfPublicId: ''})}
                        style={{background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer', fontSize: '13px', padding: 0}}
                      >
                        Supprimer
                      </button>
                    </div>
                  )}
                  {pdfFile && (
                    <div style={{marginTop: '6px', fontSize: '13px', color: '#16a34a'}}>
                      ✓ {pdfFile.name} sélectionné
                    </div>
                  )}
                  {pdfUploading && (
                    <div style={{marginTop: '6px', fontSize: '13px', color: '#4F46E5'}}>
                      Envoi du PDF en cours...
                    </div>
                  )}
                </div>
              </div>
              <label style={{display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '24px'}}>
  <input
    type="checkbox"
    checked={formData.isActive}
    onChange={(e) => setFormData({...formData, isActive: e.target.checked})}
  />
  <span style={{fontWeight: '600'}}>Événement actif </span>
</label>

              <div style={{marginBottom: '24px'}}>
                <textarea placeholder="Description" value={formData.description} onChange={(e) => setFormData({...formData, description: e.target.value})} required style={{width: '100%', padding: '10px', border: '1px solid #e2e8f0', borderRadius: '6px', minHeight: '100px'}} />
              </div>

                            {/* PROGRAMME DYNAMIQUE (programDetails) */}
              <div style={{marginBottom: '24px', backgroundColor: '#f8fafc', padding: '15px', borderRadius: '8px', border: '1px solid #e2e8f0'}}>
                <h4 style={{fontSize: '16px', fontWeight: 'bold', color: '#1e293b', marginBottom: '15px'}}>Programme par Jours (Chronogramme)</h4>
                {(formData.programDetails || []).map((day, idx) => (
                  <div key={idx} style={{marginBottom: '15px', padding: '15px', backgroundColor: 'white', border: '1px solid #cbd5e1', borderRadius: '6px'}}>
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px'}}>
                      <span style={{fontWeight: 'bold', color: '#334155'}}>Jour {idx + 1}</span>
                      <button type="button" onClick={() => {
                        const newProgram = [...(formData.programDetails || [])];
                        newProgram.splice(idx, 1);
                        setFormData({...formData, programDetails: newProgram});
                      }} style={{background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', padding: '0'}}>
                        <Trash2 size={16} />
                      </button>
                    </div>
                    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px'}}>
                      <input type="text" placeholder="Titre (ex: Jour 1)" value={day.title || ''} onChange={(e) => {
                        const newProgram = [...formData.programDetails];
                        newProgram[idx].title = e.target.value;
                        setFormData({...formData, programDetails: newProgram});
                      }} style={{padding: '8px', border: '1px solid #e2e8f0', borderRadius: '4px'}} />
                      <input type="text" placeholder="Sous-titre (ex: Arrivée)" value={day.subtitle || ''} onChange={(e) => {
                        const newProgram = [...formData.programDetails];
                        newProgram[idx].subtitle = e.target.value;
                        setFormData({...formData, programDetails: newProgram});
                      }} style={{padding: '8px', border: '1px solid #e2e8f0', borderRadius: '4px'}} />
                    </div>
                    <textarea placeholder="Description de la journée..." value={day.description || ''} onChange={(e) => {
                      const newProgram = [...formData.programDetails];
                      newProgram[idx].description = e.target.value;
                      setFormData({...formData, programDetails: newProgram});
                    }} style={{width: '100%', padding: '8px', border: '1px solid #e2e8f0', borderRadius: '4px', minHeight: '60px', marginBottom: '10px'}} />
                    <div style={{marginBottom: '10px'}}>
                      <span style={{fontSize: '12px', color: '#64748b'}}>Repas inclus : </span>
                      {['Petit Déjeuner', 'Déjeuner', 'Dîner'].map(meal => (
                        <label key={meal} style={{marginRight: '15px', fontSize: '13px', display: 'inline-flex', alignItems: 'center'}}>
                          <input type="checkbox" checked={(day.meals || []).includes(meal)} onChange={(e) => {
                            const newProgram = [...formData.programDetails];
                            if(!newProgram[idx].meals) newProgram[idx].meals = [];
                            if(e.target.checked) newProgram[idx].meals.push(meal);
                            else newProgram[idx].meals = newProgram[idx].meals.filter(m => m !== meal);
                            setFormData({...formData, programDetails: newProgram});
                          }} style={{marginRight: '5px'}}/> {meal}
                        </label>
                      ))}
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap'}}>
                      <span style={{fontSize: '12px', color: '#64748b'}}>Photo du jour :</span>
                      {day.image ? (
                        <>
                          <img src={day.image} alt="" style={{height: '52px', width: '78px', objectFit: 'cover', borderRadius: '4px', border: '1px solid #e2e8f0'}} />
                          <button type="button" onClick={() => {
                            const newProgram = [...formData.programDetails];
                            newProgram[idx] = {...newProgram[idx], image: ''};
                            setFormData({...formData, programDetails: newProgram});
                          }} style={{background: 'none', border: '1px solid #ef4444', borderRadius: '4px', color: '#ef4444', cursor: 'pointer', padding: '2px 8px', fontSize: '12px'}}>Supprimer</button>
                        </>
                      ) : (
                        <label style={{display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '4px 10px', background: '#e0f2fe', border: '1px dashed #7dd3fc', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', color: '#0369a1'}}>
                          <Plus size={13} /> Ajouter image
                          <input type="file" accept="image/*" style={{display: 'none'}} onChange={async (e) => {
                            const file = e.target.files[0];
                            if (!file) return;
                            try {
                              const url = await uploadSingleImage(file, API);
                              const newProgram = [...formData.programDetails];
                              newProgram[idx] = {...newProgram[idx], image: url};
                              setFormData({...formData, programDetails: newProgram});
                            } catch (err) { alert('Erreur upload: ' + err.message); }
                            e.target.value = '';
                          }} />
                        </label>
                      )}
                    </div>
                  </div>
                ))}
                
                <button type="button" onClick={() => {
                  const newProgram = [...(formData.programDetails || [])];
                  newProgram.push({ title: `Jour ${newProgram.length + 1}`, subtitle: '', description: '', meals: ['Petit Déjeuner'] });
                  setFormData({...formData, programDetails: newProgram});
                }} style={{display: 'flex', alignItems: 'center', gap: '5px', padding: '8px 15px', backgroundColor: '#e0f2fe', color: '#0369a1', border: '1px dashed #7dd3fc', borderRadius: '6px', fontSize: '14px', cursor: 'pointer', fontWeight: 'bold'}}>
                  <Plus size={16} /> Ajouter un jour
                </button>
              </div>
              
              {/* GALLERY / DIAPORAMA */}
              <div style={{marginBottom: '24px', backgroundColor: '#f8fafc', padding: '15px', borderRadius: '8px', border: '1px solid #e2e8f0'}}>
                <h4 style={{fontSize: '16px', fontWeight: 'bold', color: '#1e293b', marginBottom: '4px'}}>📷 Galerie / Diaporama</h4>
                <p style={{fontSize: '12px', color: '#94a3b8', marginBottom: '14px'}}>La 1ère photo sera affichée en héro. Toutes les photos sont accessibles dans le diaporama.</p>
                <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'flex-start'}}>
                  {(formData.gallery || []).map((url, idx) => (
                    <div key={idx} style={{position: 'relative', width: '110px', height: '80px', borderRadius: '6px', overflow: 'hidden', border: idx === 0 ? '2px solid #4F46E5' : '2px solid #e2e8f0', flexShrink: 0}}>
                      <img src={url} alt="" style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                      {idx === 0 && <span style={{position: 'absolute', bottom: 0, left: 0, right: 0, background: 'rgba(79,70,229,0.85)', color: 'white', fontSize: '9px', textAlign: 'center', padding: '2px', fontWeight: '700'}}>HÉRO</span>}
                      <button type="button" onClick={() => {
                        const ng = [...(formData.gallery || [])];
                        ng.splice(idx, 1);
                        setFormData({...formData, gallery: ng});
                      }} style={{position: 'absolute', top: '3px', right: '3px', background: 'rgba(220,38,38,0.9)', border: 'none', borderRadius: '50%', width: '20px', height: '20px', cursor: 'pointer', color: 'white', fontSize: '13px', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1, padding: 0, fontWeight: 'bold'}}>×</button>
                    </div>
                  ))}
                  <label style={{width: '110px', height: '80px', borderRadius: '6px', border: '2px dashed #94a3b8', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#64748b', fontSize: '12px', gap: '4px', flexShrink: 0, background: 'white'}}>
                    <Plus size={20} />
                    <span>Ajouter</span>
                    <input type="file" accept="image/*" multiple style={{display: 'none'}} onChange={async (e) => {
                      const files = Array.from(e.target.files);
                      for (const file of files) {
                        try {
                          const url = await uploadSingleImage(file, API);
                          setFormData(prev => ({...prev, gallery: [...(prev.gallery || []), url]}));
                        } catch (err) { alert('Erreur upload galerie: ' + err.message); }
                      }
                      e.target.value = '';
                    }} />
                  </label>
                </div>
              </div>

              <div style={{marginBottom: '24px'}}>
                <label style={{display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '8px'}}>Ancien format de programme (Texte brut de secours)</label>
                <textarea placeholder="Programme brut..." value={formData.program} onChange={(e) => setFormData({...formData, program: e.target.value})} style={{width: '100%', padding: '10px', border: '1px solid #e2e8f0', borderRadius: '6px', minHeight: '60px'}} />
              </div>

              <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px'}}>
                <textarea placeholder="Services inclus (séparés par des virgules)" value={formData.includedServices} onChange={(e) => setFormData({...formData, includedServices: e.target.value})} style={{padding: '10px', border: '1px solid #e2e8f0', borderRadius: '6px', minHeight: '80px'}} />
                <textarea placeholder="Services non inclus (séparés par des virgules)" value={formData.excludedServices} onChange={(e) => setFormData({...formData, excludedServices: e.target.value})} style={{padding: '10px', border: '1px solid #e2e8f0', borderRadius: '6px', minHeight: '80px'}} />
              </div>
              <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px'}}>
  <div>
    <label style={{display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '8px'}}>Détails vol</label>
    <textarea
      placeholder="Ex: Voyage en petit groupe (max 20 pers), Départs garantis minimum 10 participants"
      value={formData.voldetails}
      onChange={(e) => setFormData({...formData, voldetails: e.target.value})}
      style={{width: '100%', padding: '10px', border: '1px solid #e2e8f0', borderRadius: '6px', minHeight: '100px'}}
    />
  </div>
  <div>
    <label style={{display: 'block', fontSize: '14px', fontWeight: '600', marginBottom: '8px'}}>Autres recommandations</label>
    <textarea
      placeholder="Ex: Prendre veste chaude pour les soirées, Chaussures confortables"
      value={formData.otherRecommendations}
      onChange={(e) => setFormData({...formData, otherRecommendations: e.target.value})}
      style={{width: '100%', padding: '10px', border: '1px solid #e2e8f0', borderRadius: '6px', minHeight: '100px'}}
    />
  </div>
</div>

              <div style={{marginBottom: '24px'}}>
                <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '16px'}}>
                  <h3 style={{fontSize: '18px', fontWeight: '600'}}>Dates de départ et tarifs</h3>
                  <button type="button" onClick={addDepartureDate} style={{background: '#10b981', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px'}}>
                    <Plus size={16} /> Ajouter une date
                  </button>
                </div>

                {formData.departureDates.map((dep, idx) => (
                  <div key={idx} style={{padding: '20px', background: '#f8fafc', borderRadius: '8px', marginBottom: '20px', border: '2px solid #e2e8f0'}}>
                    <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '16px'}}>
                      <span style={{fontWeight: '700', fontSize: '16px', color: '#0f172a'}}>📅 Départ #{idx + 1}</span>
                      {formData.departureDates.length > 1 && (
                        <button type="button" onClick={() => removeDepartureDate(idx)} style={{background: '#fee2e2', color: '#dc2626', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px'}}>
                          <Trash2 size={14} /> Supprimer
                        </button>
                      )}
                    </div>

                    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '12px', marginBottom: '20px'}}>
                       <div>
                        <label style={{display: 'block', fontSize: '12px', fontWeight: '600', marginBottom: '4px', color: '#64748b'}}>Date départ *</label>
                        <input type="date" value={dep.departureDate} onChange={(e) => updateDepartureField(idx, 'departureDate', e.target.value)} required style={{width: '100%', padding: '8px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '13px'}} />
                      </div>
                      <div>
                        <label style={{display: 'block', fontSize: '12px', fontWeight: '600', marginBottom: '4px', color: '#64748b'}}>Date retour</label>
                        <input type="date" value={dep.returnDate} onChange={(e) => updateDepartureField(idx, 'returnDate', e.target.value)} style={{width: '100%', padding: '8px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '13px'}} />
                      </div>
                      <div>
                        <label style={{display: 'block', fontSize: '12px', fontWeight: '600', marginBottom: '4px', color: '#64748b'}}>Places disponibles</label>
                        <input type="number" value={dep.availableSeats} onChange={(e) => updateDepartureField(idx, 'availableSeats', e.target.value)} style={{width: '100%', padding: '8px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '13px'}} />
                      </div>
                      <div>
                        <label style={{display: 'block', fontSize: '12px', fontWeight: '600', marginBottom: '4px', color: '#64748b'}}>Statut</label>
                        <select value={dep.isAvailable} onChange={(e) => updateDepartureField(idx, 'isAvailable', e.target.value === 'true')} style={{width: '100%', padding: '8px', border: '1px solid #e2e8f0', borderRadius: '6px', fontSize: '13px'}}>
                          <option value="true">Disponible</option>
                          <option value="false">Complet</option>
                        </select>
                      </div>
                    </div>

                    {/* B2C Pricing */}
                    <div style={{padding: '16px', background: '#f0fdf4', borderRadius: '8px', marginBottom: '16px', border: '2px solid #86efac'}}>
                      <div style={{fontWeight: '700', fontSize: '14px', marginBottom: '12px', color: '#065f46'}}>💰 Tarifs B2C (Clients particuliers)</div>
                      <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px'}}>
                        <div>
                          <label style={{display: 'block', fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: '#065f46'}}>Prix base *</label>
                          <input type="number" value={dep.pricing.b2c.price} onChange={(e) => updatePricing(idx, 'b2c', 'price',Number( e.target.value))} required style={{width: '100%', padding: '8px', border: '1px solid #86efac', borderRadius: '4px', fontSize: '13px'}} />
                        </div>
                        <div>
                          <label style={{display: 'block', fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: '#065f46'}}>Demi-double</label>
                          <input type="number" value={dep.pricing.b2c.tarifdemidouble} onChange={(e) => updatePricing(idx, 'b2c', 'tarifdemidouble', e.target.value)} style={{width: '100%', padding: '8px', border: '1px solid #86efac', borderRadius: '4px', fontSize: '13px'}} />
                        </div>
                        <div>
                          <label style={{display: 'block', fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: '#065f46'}}>Suppl. single</label>
                          <input type="number" value={dep.pricing.b2c.spplementsingle} onChange={(e) => updatePricing(idx, 'b2c', 'spplementsingle', e.target.value)} style={{width: '100%', padding: '8px', border: '1px solid #86efac', borderRadius: '4px', fontSize: '13px'}} />
                        </div>
                        <div>
                          <label style={{display: 'block', fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: '#065f46'}}>Tarif 3ème lit</label>
                          <input type="number" value={dep.pricing.b2c.tarif3eme} onChange={(e) => updatePricing(idx, 'b2c', 'tarif3eme', e.target.value)} style={{width: '100%', padding: '8px', border: '1px solid #86efac', borderRadius: '4px', fontSize: '13px'}} />
                        </div>
                        <div>
                          <label style={{display: 'block', fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: '#065f46'}}>Enfant 2-6 ans</label>
                          <input type="number" value={dep.pricing.b2c.enf2_6} onChange={(e) => updatePricing(idx, 'b2c', 'enf2_6', e.target.value)} style={{width: '100%', padding: '8px', border: '1px solid #86efac', borderRadius: '4px', fontSize: '13px'}} />
                        </div>
                        <div>
                          <label style={{display: 'block', fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: '#065f46'}}>Enfant 6-12 ans</label>
                          <input type="number" value={dep.pricing.b2c.enf6_12} onChange={(e) => updatePricing(idx, 'b2c', 'enf6_12', e.target.value)} style={{width: '100%', padding: '8px', border: '1px solid #86efac', borderRadius: '4px', fontSize: '13px'}} />
                        </div>
                        <div>
  <label style={{display: 'block', fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: '#065f46'}}>Bébé (0-2 ans)</label>
  <input 
    type="number" 
    value={dep.pricing.b2c.bebe} 
    onChange={(e) => updatePricing(idx, 'b2c', 'bebe', e.target.value)} 
    style={{width: '100%', padding: '8px', border: '1px solid #86efac', borderRadius: '4px', fontSize: '13px'}} 
  />
</div>
                      </div>
                    </div>

                    {/* B2B Toggle & Pricing */}
                    <div style={{marginBottom: '12px'}}>
                      <label style={{display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', padding: '12px', background: 'white', borderRadius: '6px', border: '2px solid #e2e8f0'}}>
                        <input type="checkbox" checked={dep.pricing.b2b.enabled} onChange={(e) => updatePricing(idx, 'b2b', 'enabled', e.target.checked)} style={{width: '18px', height: '18px', cursor: 'pointer'}} />
                        <span style={{fontSize: '14px', fontWeight: '700', color: '#0f172a'}}>🤝 Activer les tarifs B2B (Professionnels)</span>
                      </label>
                    </div>

                    {dep.pricing.b2b.enabled && (
                      <div style={{padding: '16px', background: '#eff6ff', borderRadius: '8px', border: '2px solid #93c5fd'}}>
                        <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '12px', alignItems: 'center'}}>
                          <span style={{fontWeight: '700', fontSize: '14px', color: '#1e40af'}}>🤝 Tarifs B2B (Prix revendeur)</span>
                          <div style={{display: 'flex', gap: '6px'}}>
                            <button type="button" onClick={() => copyB2CtoB2B(idx)} style={{padding: '6px 12px', background: 'white', border: '1px solid #3b82f6', color: '#1e40af', borderRadius: '4px', fontSize: '11px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px', fontWeight: '600'}}>
                              <Copy size={12} /> Copier B2C
                            </button>
                            <button type="button" onClick={() => applyDiscount(idx, 10)} style={{padding: '6px 10px', background: 'white', border: '1px solid #3b82f6', color: '#1e40af', borderRadius: '4px', fontSize: '11px', cursor: 'pointer', fontWeight: '600'}}>
                              -10%
                            </button>
                            <button type="button" onClick={() => applyDiscount(idx, 15)} style={{padding: '6px 10px', background: 'white', border: '1px solid #3b82f6', color: '#1e40af', borderRadius: '4px', fontSize: '11px', cursor: 'pointer', fontWeight: '600'}}>
                              -15%
                            </button>
                            <button type="button" onClick={() => applyDiscount(idx, 20)} style={{padding: '6px 10px', background: 'white', border: '1px solid #3b82f6', color: '#1e40af', borderRadius: '4px', fontSize: '11px', cursor: 'pointer', fontWeight: '600'}}>
                              -20%
                            </button>
                          </div>
                        </div>
                        <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px'}}>
                          <div>
                            <label style={{display: 'block', fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: '#1e40af'}}>Prix base</label>
                            <input type="number" value={dep.pricing.b2b.price} onChange={(e) => updatePricing(idx, 'b2b', 'price', e.target.value)} style={{width: '100%', padding: '8px', border: '1px solid #93c5fd', borderRadius: '4px', fontSize: '13px'}} />
                          </div>
                          <div>
                            <label style={{display: 'block', fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: '#1e40af'}}>Demi-double</label>
                            <input type="number" value={dep.pricing.b2b.tarifdemidouble} onChange={(e) => updatePricing(idx, 'b2b', 'tarifdemidouble', e.target.value)} style={{width: '100%', padding: '8px', border: '1px solid #93c5fd', borderRadius: '4px', fontSize: '13px'}} />
                          </div>
                          <div>
                            <label style={{display: 'block', fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: '#1e40af'}}>Suppl. single</label>
                            <input type="number" value={dep.pricing.b2b.spplementsingle} onChange={(e) => updatePricing(idx, 'b2b', 'spplementsingle', e.target.value)} style={{width: '100%', padding: '8px', border: '1px solid #93c5fd', borderRadius: '4px', fontSize: '13px'}} />
                          </div>
                          <div>
                            <label style={{display: 'block', fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: '#1e40af'}}>Tarif 3ème lit</label>
                            <input type="number" value={dep.pricing.b2b.tarif3eme} onChange={(e) => updatePricing(idx, 'b2b', 'tarif3eme', e.target.value)} style={{width: '100%', padding: '8px', border: '1px solid #93c5fd', borderRadius: '4px', fontSize: '13px'}} />
                          </div>
                          <div>
                            <label style={{display: 'block', fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: '#1e40af'}}>Enfant 2-6 ans</label>
                            <input type="number" value={dep.pricing.b2b.enf2_6} onChange={(e) => updatePricing(idx, 'b2b', 'enf2_6', e.target.value)} style={{width: '100%', padding: '8px', border: '1px solid #93c5fd', borderRadius: '4px', fontSize: '13px'}} />
                          </div>
                          <div>
                            <label style={{display: 'block', fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: '#1e40af'}}>Enfant 6-12 ans</label>
                            <input type="number" value={dep.pricing.b2b.enf6_12} onChange={(e) => updatePricing(idx, 'b2b', 'enf6_12', e.target.value)} style={{width: '100%', padding: '8px', border: '1px solid #93c5fd', borderRadius: '4px', fontSize: '13px'}} />
                          </div>
                          <div>
  <label style={{display: 'block', fontSize: '11px', fontWeight: '600', marginBottom: '4px', color: '#1e40af'}}>Bébé (0-2 ans)</label>
  <input 
    type="number" 
    value={dep.pricing.b2b.bebe} 
    onChange={(e) => updatePricing(idx, 'b2b', 'bebe', e.target.value)} 
    style={{width: '100%', padding: '8px', border: '1px solid #93c5fd', borderRadius: '4px', fontSize: '13px'}} 
  />
</div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              <div style={{display: 'flex', gap: '12px', paddingTop: '24px', borderTop: '2px solid #e2e8f0', position: 'sticky', bottom: 0, background: 'white', marginTop: '24px'}}>
                <button type="button" onClick={() => setShowModal(false)} style={{flex: 1, padding: '14px', background: 'white', border: '2px solid #e2e8f0', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '15px', color: '#64748b'}}>
                  Annuler
                </button>
                <button type="submit" style={{flex: 1, padding: '14px', background: '#4F46E5', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '15px'}}>
                  {isEditing ? '✓ Mettre à jour' : '+ Créer l\'événement'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};






 



export default DashboardEvents;